export function hasCookie(key: string) {
	if (!key || /^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
		return false;
	}
	return new RegExp(
		'(?:^|;\\s*)' +
			encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') +
			'\\s*\\='
	).test(document.cookie);
}
